/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { InboxThreadListItemClassification } from './inboxThreadListItemClassification';
import type { InboxThreadListItemDraftStatus } from './inboxThreadListItemDraftStatus';
import type { InboxThreadListItemLastMessageDirection } from './inboxThreadListItemLastMessageDirection';
import type { InboxThreadListItemManualClassification } from './inboxThreadListItemManualClassification';

/**
 * One row in ``GET /inbox/threads`` (channel='email').
 */
export interface InboxThreadListItem {
  id: string;
  channel?: 'email';
  job_candidate_id: string;
  /** @maxLength 200 */
  candidate_name: string;
  candidate_avatar_url?: string | null;
  candidate_headline?: string | null;
  subject?: string | null;
  /** @maxLength 500 */
  snippet: string;
  last_message_at: string;
  classification?: InboxThreadListItemClassification;
  manual_classification?: InboxThreadListItemManualClassification;
  classification_confidence?: number | null;
  draft_status?: InboxThreadListItemDraftStatus;
  bounced?: boolean;
  /** @minimum 0 */
  unread_count: number;
  last_message_direction?: InboxThreadListItemLastMessageDirection;
  last_sender_name?: string | null;
  last_sender_avatar_url?: string | null;
}
